import client from './client';

export interface VillageAkim {
  id: number;
  village_name_kk: string;
  village_name_ru: string;
  akim_name: string;
  phone?: string;
  address?: string;
  is_active: boolean;
}

export interface VetService {
  id: number;
  name_ru: string;
  name_kk: string;
  service_type?: string;
  phone?: string;
  address?: string;
  is_active: boolean;
}

export interface AgroInfo {
  id: number;
  title: string;
  body: string;
  category?: string;
  is_active: boolean;
  created_at: string;
}

export const villageApi = {
  // Village Akims
  listAkims: () =>
    client.get<VillageAkim[]>('/api/admin/district/akims'),

  createAkim: (data: Partial<VillageAkim>) =>
    client.post('/api/admin/district/akims', data),

  updateAkim: (id: number, data: Partial<VillageAkim>) =>
    client.patch(`/api/admin/district/akims/${id}`, data),

  deleteAkim: (id: number) =>
    client.delete(`/api/admin/district/akims/${id}`),

  // Vet Services
  listVetServices: () =>
    client.get<VetService[]>('/api/admin/district/vet-services'),

  createVetService: (data: Partial<VetService>) =>
    client.post('/api/admin/district/vet-services', data),

  updateVetService: (id: number, data: Partial<VetService>) =>
    client.patch(`/api/admin/district/vet-services/${id}`, data),

  deleteVetService: (id: number) =>
    client.delete(`/api/admin/district/vet-services/${id}`),

  // Agro Info
  listAgroInfo: () =>
    client.get<AgroInfo[]>('/api/admin/district/agro-info'),

  createAgroInfo: (data: Partial<AgroInfo>) =>
    client.post('/api/admin/district/agro-info', data),

  updateAgroInfo: (id: number, data: Partial<AgroInfo>) =>
    client.patch(`/api/admin/district/agro-info/${id}`, data),

  deleteAgroInfo: (id: number) =>
    client.delete(`/api/admin/district/agro-info/${id}`),
};
